import React from "react";
import { useLocalDateFormat } from "../hooks/useLocalDate";
export default (function (_a) {
    var value = _a.value, _b = _a.format, format = _b === void 0 ? "MM/dd/yyyy hh:mm aa" : _b, _c = _a.defaultValue, defaultValue = _c === void 0 ? "--" : _c;
    var localDate = useLocalDateFormat(value, format);
    return React.createElement(React.Fragment, null, localDate || defaultValue);
});
//# sourceMappingURL=index.js.map